"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _basic_data_hub_api = _interopRequireDefault(require("./basic_data_hub_api"));

var _constants = require("./lib/constants");

var CardTemplatesApi =
/*#__PURE__*/
function (_BasicDataHubApi) {
  (0, _inherits2.default)(CardTemplatesApi, _BasicDataHubApi);

  function CardTemplatesApi() {
    (0, _classCallCheck2.default)(this, CardTemplatesApi);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(CardTemplatesApi).apply(this, arguments));
  }

  (0, _createClass2.default)(CardTemplatesApi, [{
    key: "copyToView",
    value: function () {
      var _copyToView = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee(cardId, viewId) {
        var binding;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.getBinding();

              case 2:
                binding = _context.sent;
                return _context.abrupt("return", binding.mutation.downloadTo({
                  entity: _constants.CARD,
                  data: {
                    id: cardId,
                    body: {
                      viewId: viewId
                    }
                  }
                }));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function copyToView(_x, _x2) {
        return _copyToView.apply(this, arguments);
      }

      return copyToView;
    }()
  }, {
    key: "getCardTemplates",
    value: function () {
      var _getCardTemplates = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee2(_ref) {
        var _ref$query, query, projection;

        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _ref$query = _ref.query, query = _ref$query === void 0 ? {} : _ref$query, projection = _ref.projection;
                return _context2.abrupt("return", this._getPaginatedList('listTemplates', {
                  entity: _constants.CARD,
                  params: {
                    queryParams: query
                  },
                  sourceId: query.sourceId,
                  forceSandbox: false
                }, projection));

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getCardTemplates(_x3) {
        return _getCardTemplates.apply(this, arguments);
      }

      return getCardTemplates;
    }()
  }, {
    key: "getCardTemplatesByToken",
    value: function () {
      var _getCardTemplatesByToken = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee3(_ref2) {
        var _ref2$query, query, projection, limit, token, binding;

        return _regenerator.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _ref2$query = _ref2.query, query = _ref2$query === void 0 ? {} : _ref2$query, projection = _ref2.projection, limit = _ref2.limit, token = _ref2.token;
                _context3.next = 3;
                return this.getBinding();

              case 3:
                binding = _context3.sent;
                return _context3.abrupt("return", binding.query.listTemplates({
                  entity: _constants.CARD,
                  params: {
                    queryParams: query,
                    limit: limit,
                    last: token
                  },
                  sourceId: query.sourceId,
                  forceSandbox: false
                }, projection || ['records', 'last']));

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getCardTemplatesByToken(_x4) {
        return _getCardTemplatesByToken.apply(this, arguments);
      }

      return getCardTemplatesByToken;
    }()
  }, {
    key: "getCardTemplateById",
    value: function () {
      var _getCardTemplateById = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee4(id) {
        var binding;
        return _regenerator.default.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getBinding();

              case 2:
                binding = _context4.sent;
                return _context4.abrupt("return", binding.query.getTemplate({
                  entity: _constants.CARD,
                  params: {
                    id: id
                  },
                  sourceId: undefined
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getCardTemplateById(_x5) {
        return _getCardTemplateById.apply(this, arguments);
      }

      return getCardTemplateById;
    }()
  }, {
    key: "getNewCardTemplate",
    value: function getNewCardTemplate() {
      // eslint-disable-line class-methods-use-this
      return {
        data: {
          presentation: {
            template: '<div class="card-form">\n  <div class="card-padding">\n    <label class="card-title">{{cardLabel}}</label>\n    <label class="card-title secondary">{{cardDescription}}</label>\n    <div class="card-content">\n    </div>\n  </div>\n</div>\n',
            code: 'return {\n  computed : { \n    cardDescription () {\n      return this.userData.description;\n    },\n\n    cardLabel () {\n      return this.userData.label;\n    },\n    \n    formData () {\n      const data = _.get(this.data, \'form.data\');\n      return _.isEmpty(data) ? {} : _.cloneDeep(data);\n    },\n    \n    presentationData () {\n      const data = _.get(this.data, \'presentation.data\');\n      return _.isEmpty(data) ? {} : _.cloneDeep(data);\n    },\n    \n    userData () {\n      const data = _.get(this.data, \'data\');\n      return _.isEmpty(data) ? {} : _.cloneDeep(data);\n    }\n  },\n  \n  created () {\n    //\n  },\n  \n  beforeDestroy () {\n    //\n  },\n  \n  data () {\n    return {\n      //\n    };\n  },\n  \n  methods : {\n    //\n  },\n  \n  mounted () {\n    // \n  },\n  \n  watch : {\n    //\n  },\n  \n  props: {\n    data: {\n      type: Object,\n      required: true\n    },\n    \n    editable: {\n      type: Boolean,\n      default: true\n    },\n    \n    sharedData : {\n      type : Object,\n      default : null\n    }\n  }\n};\n',
            style: '.card-form {\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n}\n\n.card-content {\n  display: flex;\n  flex-grow: 1;\n  display: -webkit-box;\n  -webkit-box-flex: 1;\n  display: -ms-flexbox;\n  -ms-flex-positive: 1;\n}\n\n.card-padding {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  padding: 26px 19px 19px 19px;\n}\n\n.card-title {\n  font-size: 24px;\n  font-weight: bold;\n\n  &.secondary {\n    font-weight: normal;\n    font-size: 12px;\n  }\n}\n',
            data: null
          },
          form: {
            template: '<div class="form-wrapper">\n  <or-collapsible title="Layout" class="collapsible-card-data" open disable-ripple>\n    <div class="form-row">\n      <div class="form-col">\n        <or-select label="Card height" v-model="heightOption" :options="heightOptions" placeholder="card height"></or-select>\n      </div>\n      <div class="form-col narrow" v-if="heightOption === \'height-custom-px\'">\n        <div class="textbox-right-label">\n          <or-textbox type="number" :min="100" step="10" v-model="heightInput" @change="updateCustomHeight"></or-textbox>\n          <span class="form-row-label">px</span>\n        </div>\n      </div>\n    </div>\n    <div class="form-row">\n      <div class="form-col">\n        <or-select label="Card width" v-model="widthOption" :options="widthOptions" placeholder="card width"></or-select>\n      </div>\n      <div class="form-col narrow" v-if="widthOption === \'width-custom-px\'">\n        <div class="textbox-right-label">\n          <or-textbox type="number" :min="100" step="10" v-model="widthInput" @change="updateCustomWidth"></or-textbox>\n          <span class="form-row-label">px</span>\n        </div>\n      </div>\n    </div>\n    <div class="form-row">\n      <div class="form-col custom-style">\n        <or-code v-model="styleInput" label="Card custom styles" mode="scss" @blur="saveStyles">\n        </or-code>\n      </div>\n    </div>\n  </or-collapsible>\n</div>\n',
            code: 'return {\n  computed: {\n    heightCustom: {\n      get() {\n        return _.replace(this.userData.height, /\\D+[\\s\\S]+/g, \'\');\n      },\n      set(value) {\n        this.setData([{\n          "path": "height",\n          "newSetting": `${value}px`\n        }]);\n      }\n    },\n\n    heightOption: {\n      get() {\n        return this.userData.heightOption;\n      },\n      set(value) {\n        const changes = [{\n          "path": "heightOption",\n          "newSetting": value\n        }];\n        if (value === \'height-custom-px\') {\n          changes.push({\n            "path": "height",\n            "newSetting": `${this.heightInput || this.heightMin}px`\n          });\n        } else if (value !== \'height-full-column\') {\n          changes.push({\n            "path": "height",\n            "newSetting": value\n          });\n          if (value !== \'auto\') {\n            this.heightInput = value.replace(/\\D+[\\s\\S]+/g, \'\');\n          }\n        }\n        const viewClasses = _.difference(this.userData.viewClasses, [\'height-full-column\']);\n        if (value === \'height-full-column\') {\n          viewClasses.push(\'height-full-column\');\n        }\n        if (!_.isEqual(this.userData.viewClasses, viewClasses)) {\n          changes.push({\n            "path": "viewClasses",\n            "newSetting": _.cloneDeep(viewClasses)\n          });\n        }\n        this.setData(changes);\n      }\n    },\n\n    heightOptions() {\n      return _.get(this.formData, \'heightOptions\') || [];\n    },\n\n    userData() {\n      return _.cloneDeep(this.value) || {};\n    },\n\n    widthCustom: {\n      get() {\n        return _.replace(this.userData.width, /\\D+[\\s\\S]+/g, \'\');\n      },\n      set(value) {\n        this.setData([{\n          "path": "width",\n          "newSetting": `${value}px`\n        }]);\n      }\n    },\n\n    widthOption: {\n      get() {\n        return this.userData.widthOption;\n      },\n      set(value) {\n        this.setData([{\n          "path": "widthOption",\n          "newSetting": value\n        }, {\n          "path": "viewClasses",\n          "newSetting": this.refreshWidthClass(value)\n        }]);\n      }\n    },\n\n    widthOptions() {\n      return _.get(this.formData, \'widthOptions\') || [];\n    },\n\n    widthOptionValues() {\n      return _.map(this.widthOptions, \'value\');\n    }\n  },\n\n  data() {\n    return {\n      heightInput: 100,\n      styleInput  : \'\',\n      widthInput: 100\n    }\n  },\n\n  methods: {\n    refreshWidthClass(widthClass) {\n      const viewClasses = _.difference(this.userData.viewClasses, this.widthOptionValues);\n      return widthClass === \'width-custom-px\' ? viewClasses : _.concat(viewClasses, [widthClass]);\n    },\n\n    saveStyles() {\n      this.setData([{\n        "path": "style",\n        "newSetting": _.cloneDeep(this.styleInput)\n      }]);\n    },\n\n    setData(changes, reloadCardDetails = true) {\n      try {\n        const beforeChange = _.cloneDeep(this.value);\n        const afterChange = _.cloneDeep(this.value);\n\n        _.forEach(changes, item => {\n          const path = _.get(item, \'path\');\n          if (path && _.has(item, \'newSetting\')) {\n            const newValue = _.get(item, \'newSetting\');\n            const oldValue = _.get(beforeChange, path);\n            if (!_.isEqual(newValue, oldValue)) {\n              _.set(afterChange, path, newValue);\n            }\n          }\n        });\n\n        if (!_.isEqual(afterChange, beforeChange)) {\n          this.$emit(reloadCardDetails === true ? \'input\' : \'apply-new-settings\', afterChange);\n        }\n      } catch (e) {\n        console.log(e);\n      }\n    },\n\n    updateCustomHeight(value) {\n      this.heightInput = Math.max(value, 100);\n      this.heightCustom = this.heightInput;\n\n    },\n\n    updateCustomWidth(value) {\n      this.widthInput = Math.max(value, 100);\n      this.widthCustom = this.widthInput;\n    }\n  },\n\n  mounted() {\n    this.styleInput = _.cloneDeep(this.userData.style) || \'\';\n    this.heightInput = this.heightCustom;\n    this.widthInput = this.widthCustom;\n  },\n\n  props: {\n    formData: {\n      type: Object,\n      default: null\n    },\n\n    sharedData: {\n      type: Object,\n      default: null\n    },\n\n    value: {\n      type: Object,\n      required: true\n    }\n  }\n};\n',
            style: '.form-wrapper {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  -webkit-justify-content: space-around;\n  justify-content: space-around;\n}\n\n.form-row-with-label {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n}\n\n.form-row-label {\n  font-size: 12px;\n  color: #91969d;\n  line-height: 36px;}\n\n.form-row {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: row;\n}\n\n.form-row-margin-bottom {\n  margin-bottom: 20px;\n}\n\n.form-col {\n  display: flex;\n  flex-grow: 1;\n  flex-direction: column;\n  padding-right: 10px;\n  \n  &.narrow {\n    flex-grow: 0;\n  }\n  \n  &.custom-style {\n    .or-code {\n      margin-bottom: 12px;\n    }\n  }\n}\n\n.textbox-right-label {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-end;\n  margin-top: 36px;\n  \n  .ui-textbox {\n    margin-bottom: 0;\n    margin-right: 10px;\n    width: 90px;\n  }\n}\n',
            data: {
              customForm: true,
              heightOptions: [{
                label: 'Auto',
                value: 'auto'
              }, {
                label: 'Short',
                value: '250px'
              }, {
                label: 'Medium',
                value: '350px'
              }, {
                label: 'Tall',
                value: '700px'
              }, {
                label: 'Full column',
                value: 'height-full-column'
              }, {
                label: 'Custom',
                value: 'height-custom-px'
              }],
              widthOptions: [{
                label: 'Narrow',
                value: 'width-narrow'
              }, {
                label: 'Medium',
                value: 'width-medium'
              }, {
                label: 'Wide',
                value: 'width-wide'
              }, {
                label: 'Full row',
                value: 'width-full-row'
              }, {
                label: 'Custom',
                value: 'width-custom-px'
              }]
            }
          },
          data: {
            description: 'I\'m going to build my own card template',
            height: '350px',
            heightOption: '350px',
            label: 'My custom card template',
            style: '',
            viewClasses: ['card-no-padding', 'width-medium'],
            width: '300px',
            widthOption: 'width-medium'
          }
        },
        template: {
          category: '',
          description: 'I\'m going to build my own card template',
          help: '',
          icon: '',
          iconUrl: '',
          label: 'My custom card template',
          publishedBy: '',
          tags: '',
          version: ''
        }
      };
    }
  }, {
    key: "upgrade",
    value: function () {
      var _upgrade = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee5(cardId) {
        var options,
            binding,
            _args5 = arguments;
        return _regenerator.default.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                options = _args5.length > 1 && _args5[1] !== undefined ? _args5[1] : {};
                _context5.next = 3;
                return this.getBinding();

              case 3:
                binding = _context5.sent;
                return _context5.abrupt("return", binding.mutation.upgrade({
                  entity: _constants.CARD,
                  id: cardId,
                  options: options
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function upgrade(_x6) {
        return _upgrade.apply(this, arguments);
      }

      return upgrade;
    }()
  }, {
    key: "getMostDownloaded",
    value: function () {
      var _getMostDownloaded = (0, _asyncToGenerator2.default)(
      /*#__PURE__*/
      _regenerator.default.mark(function _callee6(_ref3) {
        var _ref3$pagination, pagination, sort, projection, binding;

        return _regenerator.default.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _ref3$pagination = _ref3.pagination, pagination = _ref3$pagination === void 0 ? {
                  limit: 1000
                } : _ref3$pagination, sort = _ref3.sort, projection = _ref3.projection;
                _context6.next = 3;
                return this.getBinding();

              case 3:
                binding = _context6.sent;
                return _context6.abrupt("return", binding.query.getDownloads({
                  type: _constants.CARD.toLowerCase(),
                  pagination: pagination,
                  sort: sort
                }, projection));

              case 5:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function getMostDownloaded(_x7) {
        return _getMostDownloaded.apply(this, arguments);
      }

      return getMostDownloaded;
    }()
  }]);
  return CardTemplatesApi;
}(_basic_data_hub_api.default);

var _default = CardTemplatesApi;
exports.default = _default;